<template>
  <v-container>
    <div class="d-flex justify-space-between">
      <div class="office-title">จัดการผู้ใช้งาน</div>
      <Breadcrumbs :items="breadcrumbs" />
    </div>
    <v-card>
      <v-tabs right show-arrows>
        <template>
          <v-tab
            v-for="(tab, index) in tabs.filter(({ available }) => available)"
            :key="index"
            :to="{ name: tab.link }"
            right
            dark
            exact
          >
            <v-icon left>{{ tab.icon }}</v-icon>
            <v-badge
              :color="tab.badge ? 'danger' : 'transparent'"
              :content="tab.badge"
              small
            >
              {{ tab.title }}
            </v-badge>
          </v-tab>
        </template>
      </v-tabs>
      <v-card-text>
        <router-view></router-view>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs"

export default {
  name: "UserLayout",
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      tabs: [
        {
          title: "ผู้ใช้งาน",
          icon: "fa-user",
          link: "OfficeUser",
          badge: 0,
          available: true,
        },
        {
          title: "เพิ่มผู้ใช้งาน",
          icon: "fa-plus",
          link: "OfficeUserCreate",
          badge: 0,
          available: false,
        },
      ],
    }
  },
  computed: {
    ...mapGetters(["breadcrumbs", "currentUser", "hasRole"]),
  },
  created() {
    this.tabs[1].available = this.hasRole("admin")
  }
}
</script>